module.exports = "/images/users.8e5b97aeb4ef48bea409a808e00404c8.svg";